import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StringUtilService {
  constructor() {}

  spaceToUpperCase(str: string): string {
    return str.replace(/([A-Z])/g, ' $1').trim();
  }

  toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, function (txt: string) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  equalsIgnoringCase(text: string, other: string): boolean {
    return text.localeCompare(other, undefined, { sensitivity: 'base' }) === 0;
  }

  upperFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  lowerFirstLetter(string: string): string {
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

  isEmpty(val: any): boolean {
    if (String(val)?.trim() == '' || val == null || val == undefined) return true;
    else return false;
  }

  isEmptyIgnoreLineBreak(val: string) {
    return !!val ? this.isEmpty(val.replace(/(\r\n|\n|\r)/gm, '')) : true;
  }

  splitNewLine(val: string): string[] {
    if (this.isEmpty(val)) return [];
    let array = val.split(/\r?\n/);
    return array.filter((x) => !this.isEmpty(x));
  }

  replaceAll(str: string, search: string, replace: string): string {
    return str.replace(new RegExp(search, 'g'), replace);
  }
}
